import { render } from "./EditProposalEnterActual.vue?vue&type=template&id=b35518f6"
import script from "./EditProposalEnterActual.vue?vue&type=script&lang=js"
export * from "./EditProposalEnterActual.vue?vue&type=script&lang=js"

import "./EditProposalEnterActual.vue?vue&type=style&index=0&id=b35518f6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__